export const getPageInfo = (page) => {
  const { number, totalElements, size } = page || {};
  const viewCountFrom = number * size + 1;
  const viewCountTo = Math.min(totalElements, viewCountFrom + size - 1);

  return { ...page, viewCountFrom, viewCountTo };
};
